{
  "breaches": {
    "count": "Les informations de votre compte ont été exposées dans {count} fuites de données.",
    "discovered": "Cette fuite a été découverte le {date}.",
    "empty": {
      "text": "Nous n’avons trouvé aucune fuite de données concernant votre compte.",
      "title": "Aucune fuite de données trouvée"
    },
    "high": "Élevé",
    "medium": "Moyen",
    "title": "Fuites de données",
    "watchlist": {
      "button": "Ajouter une adresse e-mail",
      "text": "Adresses e-mail surveillées",
      "title": "Liste de surveillance"
    }
  },
  "cards": {
    "breaches": {
      "text": "Sur cette page, vous pouvez consulter le nombre de fuites de données concernant votre compte. Nous les classons selon leur gravité et le type de données exposées. Pensez à changer vos mots de passe si vos données ont été compromises.",
      "title": "Vos données ont-elles été divulguées ?"
    },
    "overview": {
      "text": "Bonjour {name} ! Comme vous le savez peut-être, les attaques de phishing deviennent de plus en plus complexes et dangereuses. Le Hub vous permet de suivre vos progrès et d’en apprendre davantage sur les cyberattaques qui menacent votre entreprise. Relevez les défis de sécurité et devenez rapidement un expert.",
      "title": "Bienvenue sur le Hub !"
    },
    "quiz": {
      "text": "Testez vos compétences avec ce quiz interactif et apprenez à distinguer les e-mails légitimes des tentatives de phishing. Ce quiz évalue vos connaissances et votre compréhension des menaces réelles.",
      "title": "Testez vos connaissances !"
    },
    "simulations": {
      "text": "Sur cette page, vous pouvez consulter les détails des simulations Moxso reçues au cours des 90 derniers jours. Comprendre comment les e-mails de phishing sont conçus vous aidera à les reconnaître et à vous en protéger.",
      "title": "Avez-vous été piégé par un phishing ?"
    },
    "videos": {
      "text": "Sur cette page, vous pouvez regarder des vidéos sur les dernières cybermenaces et apprendre à vous protéger, vous et votre entreprise. Nos vidéos de formation sont disponibles à tout moment.",
      "title": "À vos marques, prêts, action !"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certificat de réussite",
    "certificate_unlocked": "Certificat débloqué",
    "share_on_linkedin": "Partager sur LinkedIn",
    "show_certificate": "Afficher le certificat",
    "text": "Vous avez obtenu un certificat pour une formation récente. Pourquoi ne pas le partager ?"
  },
  "courses": {
    "all": "Toutes les formations",
    "completed": {
      "badge": "Terminé",
      "button": "Terminer la formation",
      "text": "Vous avez terminé la formation",
      "title": "Bravo !"
    },
    "content": {
      "breach": {
        "text": "Activez la détection des fuites de données pour votre compte",
        "title": "Configurer la détection des fuites de données"
      },
      "download": {
        "button": "Télécharger"
      },
      "introduction": {
        "contents": "Sommaire",
        "start": "Commencer la formation",
        "text": "Introduction et présentation de la formation",
        "title": "Introduction"
      },
      "quiz": {
        "choose_answer": "Choisissez la bonne réponse ci-dessous :",
        "correct": "Correct",
        "correct_answer": "{label} : {answer}",
        "correct_answer_label": "Bonne réponse",
        "next_question": "Question suivante",
        "oh_no": "Dommage !",
        "question_of": "Question {current} sur {total}",
        "result": {
          "button": "Terminer le quiz",
          "text": "Vous avez répondu correctement à {correct} questions sur {total}.",
          "title": "Bravo !",
          "title_fail": "Vous y êtes presque !"
        },
        "text": "Testez vos compétences avec un quiz",
        "title": "Quiz",
        "view_results": "Voir le résultat",
        "well_done": "Bravo !",
        "your_answer": "{label} : {answer}",
        "your_answer_label": "Votre réponse"
      },
      "video": {
        "text": "Découvrez les notions essentielles en regardant cette vidéo"
      }
    },
    "continue": "Continuer",
    "featured": "Formations à la une",
    "lessons": "{count} leçons",
    "progress": {
      "button": "Continuer",
      "text": "Vous avez terminé {pct} % de cette formation"
    },
    "skip_video": {
      "button": "Passer",
      "text": "Vous avez déjà regardé cette vidéo. Voulez-vous la passer ?"
    },
    "start_over": "Recommencer",
    "title": "Formations"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "La question a expiré",
        "network": "Une erreur s’est produite",
        "noResponse": "Aucune réponse n’a été reçue du serveur",
        "streaming": {
          "manifest": "Une erreur s’est produite lors de la lecture de la vidéo",
          "platform": "Cette vidéo n’est pas compatible avec votre appareil",
          "unavailable": "Cette vidéo n’est pas disponible"
        },
        "unknown": "Une erreur inconnue s’est produite"
      },
      "messages": {
        "auth_failed": "Adresse e-mail non valide",
        "csrf": "Actualisez la page et réessayez",
        "email_missing": "Aucune adresse e-mail n’est associée au compte",
        "file_not_found": "Fichier introuvable",
        "general_exception": "Une erreur s’est produite",
        "invalid_answer": "Réponse non valide",
        "invalid_course": "Formation non valide",
        "invalid_domain": "Domaine non valide",
        "invalid_email": "Adresse e-mail non valide",
        "invalid_grant": "Impossible de contacter le fournisseur",
        "invalid_locale": "Traduction introuvable",
        "invalid_option": "Option non valide",
        "invalid_permissions": "Vous n’êtes pas autorisé à utiliser cette fonctionnalité",
        "invalid_point": "Point non valide",
        "invalid_provider": "Fournisseur non valide",
        "invalid_quiz": "Quiz non valide",
        "invalid_token": "Votre session a expiré",
        "invalid_video": "Vidéo non valide",
        "missing_code": "Veuillez réessayer",
        "two_factor_code_expired": "Le code d’authentification à deux facteurs a expiré",
        "two_factor_code_invalid": "Le code d’authentification à deux facteurs n’est pas valide",
        "unauthorized": "Vous n’êtes pas autorisé à utiliser cette fonctionnalité",
        "user_not_found": "L’utilisateur n’existe pas"
      },
      "validations": {
        "messages": {
          "throttle": "Trop de tentatives de connexion. Veuillez réessayer plus tard."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Soldes de comptes",
        "address_book_contacts": "Contacts du carnet d’adresses",
        "age_groups": "Tranches d’âge",
        "ages": "Âges",
        "appointments": "Rendez-vous",
        "apps_installed_on_devices": "Applications installées sur les appareils",
        "astrological_signs": "Signes astrologiques",
        "audio_recordings": "Enregistrements audio",
        "auth_tokens": "Jetons d’authentification",
        "avatars": "Avatars",
        "bank_account_numbers": "Numéros de comptes bancaires",
        "beauty_ratings": "Évaluations de beauté",
        "biometric_data": "Données biométriques",
        "bios": "Biographies",
        "browser_user_agent_details": "Informations sur l’agent utilisateur du navigateur",
        "browsing_histories": "Historiques de navigation",
        "buying_preferences": "Préférences d’achat",
        "car_ownership_statuses": "Statuts de propriété automobile",
        "career_levels": "Niveaux de carrière",
        "cellular_network_names": "Noms de réseaux mobiles",
        "charitable_donations": "Dons caritatifs",
        "chat_logs": "Historiques de discussion",
        "credit_card_cvv": "Cryptogrammes des cartes de crédit",
        "credit_cards": "Cartes de crédit",
        "credit_status_information": "Informations sur la solvabilité",
        "customer_feedback": "Avis des clients",
        "customer_interactions": "Interactions avec les clients",
        "dates_of_birth": "Dates de naissance",
        "deceased_date": "Date de décès",
        "deceased_statuses": "Statuts de décès",
        "device_information": "Informations sur les appareils",
        "device_serial_numbers": "Numéros de série des appareils",
        "device_usage_tracking_data": "Données de suivi de l’utilisation des appareils",
        "drinking_habits": "Habitudes de consommation d’alcool",
        "driver_s_licenses": "Permis de conduire",
        "drug_habits": "Habitudes de consommation de drogues",
        "eating_habits": "Habitudes alimentaires",
        "education_levels": "Niveaux d’études",
        "email_addresses": "Adresses e-mail",
        "email_messages": "Messages électroniques",
        "employers": "Employeurs",
        "employment_statuses": "Situations professionnelles",
        "encrypted_keys": "Clés chiffrées",
        "ethnicities": "Origines ethniques",
        "family_members_names": "Noms des membres de la famille",
        "family_plans": "Projets familiaux",
        "family_structure": "Structure familiale",
        "financial_investments": "Investissements financiers",
        "financial_transactions": "Transactions financières",
        "fitness_levels": "Niveaux de condition physique",
        "genders": "Genres",
        "geographic_locations": "Localisations géographiques",
        "government_issued_i_ds": "Pièces d’identité officielles",
        "health_insurance_information": "Informations sur l’assurance maladie",
        "historical_passwords": "Anciens mots de passe",
        "hiv_statuses": "Statuts sérologiques VIH",
        "home_loan_information": "Informations sur les prêts immobiliers",
        "home_ownership_statuses": "Statuts de propriété du logement",
        "homepage_ur_ls": "URL des pages d’accueil",
        "imei_numbers": "Numéros IMEI",
        "imsi_numbers": "Numéros IMSI",
        "income_levels": "Niveaux de revenus",
        "instant_messenger_identities": "Identifiants de messagerie instantanée",
        "ip_addresses": "Adresses IP",
        "job_applications": "Candidatures à un emploi",
        "job_titles": "Intitulés de poste",
        "licence_plates": "Plaques d’immatriculation",
        "living_costs": "Coûts de la vie",
        "login_histories": "Historiques de connexion",
        "mac_addresses": "Adresses MAC",
        "marital_statuses": "États civils",
        "mnemonic_phrases": "Phrases mnémoniques",
        "mothers_maiden_names": "Noms de jeune fille des mères",
        "names": "Noms",
        "nationalities": "Nationalités",
        "net_worths": "Patrimoines nets",
        "nicknames": "Pseudonymes",
        "occupations": "Professions",
        "parenting_plans": "Plans parentaux",
        "partial_credit_card_data": "Données partielles de cartes de crédit",
        "partial_dates_of_birth": "Dates de naissance partielles",
        "passport_numbers": "Numéros de passeport",
        "password_hints": "Indices de mots de passe",
        "password_strengths": "Robustesse des mots de passe",
        "passwords": "Mots de passe",
        "payment_histories": "Historiques de paiement",
        "payment_methods": "Moyens de paiement",
        "personal_descriptions": "Descriptions personnelles",
        "personal_health_data": "Données de santé personnelles",
        "personal_interests": "Centres d’intérêt personnels",
        "phone_numbers": "Numéros de téléphone",
        "photos": "Photos",
        "physical_addresses": "Adresses postales",
        "physical_attributes": "Caractéristiques physiques",
        "pi_ns": "Codes PIN",
        "places_of_birth": "Lieux de naissance",
        "political_donations": "Dons politiques",
        "political_views": "Opinions politiques",
        "private_messages": "Messages privés",
        "professional_skills": "Compétences professionnelles",
        "profile_photos": "Photos de profil",
        "purchases": "Achats",
        "purchasing_habits": "Habitudes d’achat",
        "races": "Races",
        "recovery_email_addresses": "Adresses e-mail de récupération",
        "relationship_statuses": "Situations amoureuses",
        "religions": "Religions",
        "reward_program_balances": "Soldes des programmes de fidélité",
        "salutations": "Civilités",
        "school_grades_class_levels": "Niveaux scolaires",
        "security_questions_and_answers": "Questions et réponses de sécurité",
        "sexual_fetishes": "Fétichismes sexuels",
        "sexual_orientations": "Orientations sexuelles",
        "smoking_habits": "Habitudes de consommation de tabac",
        "sms_messages": "Messages SMS",
        "social_connections": "Relations sociales",
        "social_media_profiles": "Profils sur les réseaux sociaux",
        "social_security_numbers": "Numéros de sécurité sociale",
        "spoken_languages": "Langues parlées",
        "spouses_names": "Noms des conjoints",
        "support_tickets": "Tickets d’assistance",
        "survey_results": "Résultats d’enquêtes",
        "taxation_records": "Dossiers fiscaux",
        "telecommunications_carrier": "Opérateur de télécommunications",
        "time_zones": "Fuseaux horaires",
        "travel_habits": "Habitudes de voyage",
        "user_statuses": "Statuts des utilisateurs",
        "user_website_ur_ls": "URL des sites web des utilisateurs",
        "usernames": "Noms d’utilisateur",
        "utility_bills": "Factures de services publics",
        "vehicle_details": "Informations sur les véhicules",
        "website_activity": "Activité sur les sites web",
        "work_habits": "Habitudes de travail",
        "years_of_professional_experience": "Années d’expérience professionnelle"
      }
    },
    "certificates": {
      "compliance": "Formation en cybersécurité"
    },
    "courses": {
      "toc": {
        "breach-content": "Fuites de données",
        "file-content": "Télécharger",
        "intro-content": "Introduction",
        "quiz-content": "Quiz",
        "text-content": "Cas pratique",
        "video-content": "Vidéo"
      }
    },
    "locales": {
      "current": "Français",
      "da_DK": "Danois",
      "de_DE": "Allemand",
      "en_US": "Anglais",
      "es_ES": "Espagnol",
      "fi_FI": "Finnois",
      "fr_FR": "Français",
      "nb_NO": "Norvégien",
      "nl_NL": "Néerlandais",
      "pl_PL": "Polonais",
      "pt_PT": "Portugais",
      "sv_SE": "Suédois"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Bienvenue sur votre plateforme d’apprentissage personnalisée ! Nous sommes ravis de vous accueillir et avons hâte de vous aider à atteindre vos objectifs de formation.",
              "title": "Bienvenue sur Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Comment fonctionne Moxso",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "C’est parti ! 🙌\n",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Connaissance de la confidentialité des données",
          "options": {
            "high": "Je les connais",
            "low": "Je ne les connais pas",
            "medium": "Je les connais un peu"
          },
          "question": "Dans quelle mesure connaissez-vous les principes de base de la confidentialité des données, comme le RGPD ?"
        },
        "device_security": {
          "category": "Pratiques de sécurité des appareils",
          "options": {
            "high": "Oui, toujours",
            "low": "Non, jamais",
            "medium": "Parfois"
          },
          "question": "Mettez-vous régulièrement à jour vos appareils et utilisez-vous des outils de sécurité comme un VPN ?"
        },
        "digital_threats": {
          "category": "Connaissance des menaces numériques",
          "options": {
            "high": "Je les connais",
            "low": "Je ne les connais pas",
            "medium": "Je les connais un peu"
          },
          "question": "Dans quelle mesure connaissez-vous les menaces numériques comme les logiciels malveillants, le phishing et les rançongiciels ?"
        },
        "hybrid_work": {
          "category": "Sécurité du télétravail",
          "options": {
            "high": "Très à l’aise",
            "low": "Pas à l’aise",
            "medium": "Plutôt à l’aise"
          },
          "question": "Dans quelle mesure êtes-vous à l’aise pour assurer votre sécurité en télétravail, par exemple sur un réseau Wi-Fi public ?"
        },
        "incidents_breaches": {
          "category": "Signalement des incidents",
          "options": {
            "high": "Oui",
            "low": "Non",
            "medium": "J’en ai une idée générale"
          },
          "question": "Connaissez-vous la procédure à suivre pour signaler un incident de sécurité ou une fuite de données ?"
        },
        "passwords_accounts": {
          "category": "Gestion des mots de passe",
          "options": {
            "high": "J’utilise un gestionnaire de mots de passe",
            "low": "Je réutilise mes mots de passe",
            "medium": "Je crée des mots de passe uniques et robustes"
          },
          "question": "Comment gérez-vous les mots de passe de vos comptes professionnels ?"
        },
        "phishing": {
          "category": "Identification du phishing",
          "options": {
            "high": "Très à l’aise",
            "low": "Pas à l’aise",
            "medium": "Plutôt à l’aise"
          },
          "question": "Dans quelle mesure êtes-vous à l’aise pour reconnaître les tentatives de phishing dans les e-mails ou les messages ?"
        },
        "physical_security": {
          "category": "Pratiques de sécurité physique",
          "options": {
            "high": "Toujours",
            "low": "Rarement",
            "medium": "Parfois"
          },
          "question": "À quelle fréquence sécurisez-vous votre espace de travail, par exemple en verrouillant votre ordinateur ou en rangeant les documents sensibles ?"
        },
        "secure_browsing": {
          "category": "Habitudes de navigation sécurisée",
          "options": {
            "high": "Oui, toujours",
            "low": "Non, jamais",
            "medium": "Parfois"
          },
          "question": "Évitez-vous d’utiliser les réseaux Wi-Fi publics ou de cliquer sur des liens suspects lorsque vous naviguez ?"
        }
      },
      "steps": {
        "finished": "Terminé",
        "introduction": "Introduction",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "cancer": "la Société danoise contre le cancer",
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Somme de contrôle non valide",
        "option": "Réponse non reconnue"
      },
      "intro": {
        "button": "Commencer le quiz",
        "text": "Nous allons examiner 5 e-mails de votre boîte de réception Moxso. Certains pourraient provenir d’escrocs cherchant à accéder à des données sensibles. À vous de décider s’il s’agit de phishing ou non. Vous êtes prêt ?",
        "title": "Prêt à signaler ?"
      },
      "multiple-choice": {
        "heading": "Trouvez l’erreur dans cet e-mail",
        "text": "Texte d’aide pour les questions à choix multiples"
      },
      "options": {
        "email": "L’e-mail",
        "false": "Ce n’est PAS du phishing",
        "help": {
          "email": "L’expéditeur n’est PAS fiable",
          "false": "Cet e-mail ne doit PAS être signalé",
          "link": "Le lien ne mène PAS vers une destination fiable",
          "not-phishing": "Ce n’est PAS du phishing",
          "true": "Cet e-mail doit être signalé"
        },
        "link": "Le lien",
        "not-phishing": "Ce n’est PAS du phishing",
        "true": "C’est BIEN du phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Cet e-mail est-il une tentative de phishing ?",
        "text": "Déterminez si cet e-mail est une tentative de phishing ou non"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Cette formation n’est pas accessible. Les formations facultatives sont verrouillées, mais les formations obligatoires restent toujours disponibles.",
          "title": "Cette formation est verrouillée"
        },
        "quiz": {
          "description": "Vous avez atteint votre limite de formation. Les quiz facultatifs sont verrouillés pour le moment.",
          "title": "Limite de quiz atteinte"
        },
        "video": {
          "description": "Vous avez atteint votre limite de formation. Les vidéos facultatives sont verrouillées, mais les formations obligatoires restent toujours disponibles.",
          "title": "Limite de vidéos atteinte"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Cette formation n’est pas accessible. Les formations facultatives sont verrouillées, mais les formations obligatoires restent toujours disponibles.",
        "title": "Cette formation est verrouillée"
      },
      "quiz": {
        "description": "Vous avez atteint votre limite de formation. Les quiz facultatifs sont verrouillés pour le moment.",
        "title": "Limite de quiz atteinte"
      },
      "reset": "Réinitialisation le lundi",
      "video": {
        "description": "Vous avez atteint votre limite de formation. Les vidéos facultatives sont verrouillées, mais les formations obligatoires restent toujours disponibles.",
        "limit_reached": "Limite atteinte",
        "title": "Limite de vidéos atteinte"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "La série Avancé s’adresse aux personnes qui s’intéressent particulièrement à la cybersécurité et souhaitent comprendre les mécanismes du piratage et de la cybersécurité. Si vous recherchez uniquement des connaissances de base, il n’est pas nécessaire de regarder ces vidéos. Si vous souhaitez approfondir vos connaissances du piratage, des cyberattaques et des meilleures façons de renforcer votre cybersécurité, cette série est faite pour vous.",
          "title": "Avancé",
          "tooltip": "Devenez rapidement un expert du piratage"
        },
        "ai": {
          "text": "La série sur l’IA explore le rôle complexe de l’intelligence artificielle dans la cybersécurité. L’IA a un double usage : elle est essentielle aux professionnels de la sécurité informatique pour identifier et contrer les menaces, mais constitue aussi un outil puissant pour les pirates. Cette série vous aide à reconnaître le phishing généré par l’IA et à utiliser celle-ci en toute sécurité pour réduire les erreurs et les risques de piratage. Bien que l’IA soit un outil puissant pour les défenseurs comme pour les attaquants, votre comportement reste déterminant pour votre sécurité.",
          "title": "IA et cybersécurité",
          "tooltip": "Découvrez le rôle complexe de l’IA dans la cybersécurité"
        },
        "compliance": {
          "text": "Cette catégorie propose des vidéos sur les lois, les normes de sécurité et les certifications importantes pour protéger votre lieu de travail contre les menaces numériques. Vous découvrirez notamment la directive NIS2 et le règlement DORA, qui imposent des mesures robustes de cybersécurité et le respect des normes internationales. Les vidéos expliquent l’importance de ces réglementations, comment s’y conformer et leurs exigences en matière de sécurité et de gestion des risques. Vous comprendrez également leurs implications pour vous et pourquoi elles méritent votre attention.",
          "title": "Certifications et conformité",
          "tooltip": "Comprenez l’importance des certifications et de la conformité"
        },
        "gdpr": {
          "text": "La série RGPD approfondit les règles, les exigences et les principes du Règlement général sur la protection des données. Entré en application en 2018, le RGPD doit être respecté par les entreprises afin de garantir l’intégrité et la protection des données personnelles qu’elles traitent. La série couvre les principaux aspects à connaître pour traiter correctement les données personnelles au quotidien. Ses vidéos s’adressent à tous, y compris aux salariés du secteur privé.",
          "title": "RGPD",
          "tooltip": "Découvrez les principales exigences du RGPD et comment les respecter au quotidien"
        },
        "hacking": {
          "text": "La vie d’un pirate est une série consacrée aux personnes derrière les cyberattaques. Nous examinerons certaines méthodes utilisées pour rester anonymes en ligne et la façon dont les pirates gagnent de l’argent. Les vidéos expliquent également les différents types de pirates et pourquoi ils sont si difficiles à arrêter.",
          "title": "La vie d’un pirate",
          "tooltip": "Découvrez les personnes derrière les cyberattaques"
        },
        "money_laundering": {
          "text": "La série Blanchiment d’argent explore les méthodes utilisées par les criminels pour blanchir de l’argent. Les vidéos expliquent ces techniques et comment détecter et prévenir le blanchiment d’argent.",
          "title": "Blanchiment d’argent",
          "tooltip": "Découvrez les méthodes de blanchiment d’argent et comment les détecter et les prévenir"
        },
        "phishing": {
          "text": "La série Phishing explore la cyberattaque la plus courante au monde. Le phishing peut constituer une attaque en soi ou servir à lancer d’autres attaques plus avancées. Votre comportement en tant que salarié est essentiel pour l’éviter, par exemple en ne cliquant pas sur un lien dans un e-mail. Le phishing est un sujet central de la cybersécurité. Ces vidéos vous aideront à comprendre ce qu’il est, comment les pirates le mettent en œuvre et comment éviter d’en être victime.",
          "title": "Phishing",
          "tooltip": "Découvrez les aspects de la cyberattaque la plus courante au monde"
        },
        "physical_security": {
          "text": "La série Sécurité physique souligne l’importance d’une bonne sécurité au travail et à la maison. La cybersécurité ne concerne pas seulement vos appareils, mais aussi leur *environnement*. Le télétravail est courant, et nous vous aiderons à le pratiquer de la manière la plus sûre possible. Cette série aborde également la gestion des visiteurs, la sécurité des appareils mobiles et les risques des réseaux publics.",
          "title": "Sécurité physique",
          "tooltip": "Découvrez pourquoi la sécurité physique est essentielle à une bonne cybersécurité"
        },
        "tips_and_tricks": {
          "text": "La série Conseils et astuces vous aidera à renforcer votre cybersécurité. Vous découvrirez des moyens concrets et simples d’améliorer votre sécurité personnelle en ligne et, par conséquent, celle de votre lieu de travail. Les vidéos expliquent aussi pourquoi il est important de retenir les conseils de cybersécurité reçus précédemment.",
          "title": "Conseils et astuces",
          "tooltip": "Apprenez à renforcer votre cybersécurité personnelle"
        },
        "types_of_hacking": {
          "text": "La série Types de piratage présente les différentes méthodes utilisées par les pirates pour vous tromper. Chaque épisode explique les caractéristiques d’une technique, ce que les pirates peuvent en tirer et les conséquences possibles pour vous en cas d’attaque. Ces vidéos vous aideront à mieux vous préparer face aux attaques futures.",
          "title": "Types de piratage",
          "tooltip": "Découvrez les différentes méthodes utilisées par les pirates"
        },
        "uploads": {
          "text": "Cette catégorie contient des vidéos personnalisées mises en ligne par votre organisation.",
          "title": "Vidéos mises en ligne",
          "tooltip": "Regardez les vidéos mises en ligne par votre organisation pour vos besoins spécifiques de sécurité"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "L’erreur a été signalée à notre équipe sous l’identifiant {errorId}.\n Si vous avez besoin d’une aide immédiate, contactez notre assistance à l’adresse support{'@'}moxso.com.",
    "go_back": "Retour à l’accueil",
    "text": "Une erreur inconnue s’est produite et nous n’avons pas pu traiter votre demande. Nous sommes désolés pour la gêne occasionnée. Veuillez réessayer plus tard.",
    "title": "Une erreur s’est produite"
  },
  "forms": {
    "fields": {
      "code": "Mot de passe à usage unique",
      "email": "E-mail"
    },
    "placeholders": {
      "email": "nom{'@'}entreprise.com"
    }
  },
  "loading": "Chargement",
  "locale": {
    "current": "Français",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Se connecter",
      "next": "Suivant",
      "send_one_time_code": "Envoyer un code à usage unique",
      "try_again": "Renvoyer le code"
    },
    "choose_provider": "Choisir un fournisseur",
    "loading": "Chargement",
    "sso": {
      "validating": "Validation de l’authentification unique"
    },
    "title": "Connexion",
    "two_factor": {
      "text": "Nous vous avons envoyé un mot de passe à usage unique par e-mail.",
      "title": "Consultez votre messagerie"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Vous avez terminé le contenu à la une sélectionné par votre administrateur.",
      "title": "Bravo !"
    },
    "deadline": "Date limite : {date}",
    "next_training": "Prochaine formation attribuée",
    "policy_fallback_title": "Politique",
    "quiz_questions": "{count} question | {count} questions",
    "retake": "Réattribué",
    "start_quiz": "Commencer le quiz",
    "text": "Vos formations attribuées",
    "title": "Formations attribuées",
    "view_policy": "Consulter la politique"
  },
  "navigation": {
    "breaches": "Fuites de données",
    "courses": "Formations",
    "exit": "Quitter",
    "exit_onboarding": "Passer l’intégration",
    "login": "Se connecter",
    "logout": "Se déconnecter",
    "onboarding": "Introduction",
    "onboarding_finished": "Intégration terminée",
    "onboarding_intro": "Présentation du parcours d’intégration",
    "onboarding_quiz": "Quiz d’intégration",
    "overview": "Vue d’ensemble",
    "simulation_click": "Simulation de phishing",
    "simulations": "Simulations",
    "videos": "Vidéos"
  },
  "onboarding": {
    "finished": {
      "button": "Commencer à apprendre",
      "subtitle": "Vous avez terminé votre parcours d’intégration ! Bravo, vous pouvez maintenant utiliser Moxso. Nous sommes ravis de vous accueillir et avons hâte de vous aider à atteindre vos objectifs !",
      "title": "C’est terminé !"
    },
    "intro": {
      "form": {
        "button": "Enregistrer et continuer",
        "help": "Choisissez la langue que vous souhaitez utiliser pour votre formation.",
        "label": "Sélectionnez votre langue",
        "placeholder": "Sélectionner une langue"
      },
      "header": {
        "description": "Bienvenue sur votre plateforme d’apprentissage ! Nous sommes ravis de vous accueillir et prêts à vous aider à atteindre vos objectifs. Configurons votre profil et personnalisons votre expérience.",
        "title": "Bienvenue sur Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Répondez à ce court quiz pour nous aider à comprendre votre niveau actuel et à adapter la formation à vos besoins.",
        "title": "Que savez-vous de la cybersécurité ?"
      }
    }
  },
  "overview": {
    "start_quiz": "Commencer un quiz",
    "welcome": "Heureux de vous revoir"
  },
  "partner_text": "La plateforme Moxso vous est proposée en collaboration avec {partner}.",
  "policies": {
    "cancel": {
      "text": "Cette politique a été annulée par votre administrateur.",
      "title": "Politique annulée"
    },
    "continue": "Continuer",
    "expired": {
      "text": "Cette politique a expiré et n’est plus disponible.",
      "title": "Politique expirée"
    },
    "focus": "Concentration",
    "history": {
      "count": "{count} signées",
      "show_less": "Afficher moins",
      "signed": "Signée le {date}",
      "subtitle": "Consulter les politiques signées",
      "title": "Politiques",
      "view_more": "Afficher plus"
    },
    "next": "Suivant",
    "overview": "Vue d’ensemble du contenu",
    "policy": "Politique",
    "quiz": {
      "confirmation_card_locked": "Vous devez terminer le quiz pour continuer",
      "subtitle": "Montrez que vous comprenez la politique en répondant à ce quiz.",
      "subtitle_completed": "Vous avez terminé le quiz. Confirmez la lecture de la politique pour terminer.",
      "title": "Quiz",
      "title_completed": "Quiz terminé"
    },
    "reader": "Lecteur",
    "signature": {
      "button": "Confirmer",
      "checkbox_label": "J’ai lu la politique",
      "company": "Entreprise",
      "completed": {
        "button": "Quitter",
        "policy_completed": "Politique acceptée",
        "subtitle": "Bravo ! Vous avez accepté la politique.",
        "title": "Politique acceptée"
      },
      "ip_adress": "Adresse IP",
      "subtitle": "En confirmant, vous reconnaissez avoir lu et compris la politique.",
      "title": "Confirmer la lecture de la politique",
      "user_agent": "Agent utilisateur"
    },
    "this_policy_doesnt_exist_in_this_language": "Cette politique n’est pas disponible en français. La version en {locale} est affichée."
  },
  "quiz": {
    "analyze": {
      "text": "Analysez cet e-mail et obtenez de l’aide",
      "title": "Un doute ?"
    },
    "feedback": {
      "no": "Non",
      "text": "Cette page vous a-t-elle été utile ?",
      "thanks": "Merci pour votre avis !",
      "yes": "Oui"
    },
    "help": {
      "button": "Question suivante",
      "text": "Nous avons analysé l’e-mail et obtenu le résultat suivant",
      "title": "Analyse de l’e-mail"
    },
    "intro": {
      "button": "Commencer le quiz",
      "text": "Nous allons examiner 5 e-mails de votre boîte de réception Moxso. Certains pourraient provenir d’escrocs cherchant à accéder à des données sensibles. À vous de décider s’il s’agit de phishing ou non. Vous êtes prêt ?",
      "title": "Prêt à signaler ?"
    },
    "preview": "Aperçu de l’e-mail",
    "question": "Question {current} sur {total}",
    "result": {
      "go_back": "Accéder à votre vue d’ensemble",
      "mails": "E-mail détecté | E-mails détectés",
      "points": "Points gagnés",
      "text": {
        "bad": "Vous n’avez malheureusement classé correctement que {count} e-mail. Mais n’oubliez pas : c’est en pratiquant que l’on progresse ! | Vous n’avez malheureusement classé correctement que {count} e-mails. Mais n’oubliez pas : c’est en pratiquant que l’on progresse !",
        "good": "Vous avez classé correctement {count} e-mails et terminé le quiz. Continuez comme ça !"
      },
      "title": {
        "bad": "Vous ferez mieux la prochaine fois",
        "good": "Bravo !"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "Le score de résilience mesure votre capacité à résister aux cyberattaques. Il est calculé à partir de votre comportement dans les quiz, les vidéos et les simulations, ainsi que de vos compétences. Plus votre score est élevé, mieux vous pouvez vous protéger et protéger votre lieu de travail contre les cyberattaques.",
    "quizzing": {
      "text": "Améliorez vos résultats aux quiz à choix multiples pour renforcer votre résilience.",
      "title": "Quiz"
    },
    "show_breakdown": "Afficher le détail",
    "simulations": {
      "text": "Adopter les bons réflexes face au phishing améliore votre résilience. Ne cliquez pas et pensez à signaler !",
      "title": "Simulations"
    },
    "skills": {
      "text": "Vos compétences dépendent de vos résultats aux quiz. Les bonnes réponses renforcent votre résilience.",
      "title": "Compétences"
    },
    "text": "Le score de résilience mesure votre capacité à résister aux cyberattaques.",
    "title": "Votre score de résilience",
    "videos": {
      "text": "Les vidéos sont une partie importante de votre formation. Renforcez votre résilience en les regardant.",
      "title": "Vidéos"
    }
  },
  "search": {
    "empty": "Effectuez une recherche pour commencer...",
    "no_results": "Aucun résultat trouvé",
    "placeholder": "Rechercher...",
    "popular": "Recherches populaires",
    "popular_terms": ["Rançongiciel", "Ingénierie sociale"]
  },
  "simulation": {
    "alert": {
      "text": "Cet e-mail fait partie d’un exercice automatisé de phishing, mais rassurez-vous : ce n’est qu’un test.",
      "title": "Ceci est une simulation de phishing"
    },
    "baseline": {
      "text": "Nous testons actuellement vos collègues. Merci de ne pas partager ce message.",
      "title": "Pouvez-vous garder un secret ?"
    },
    "branding": {
      "text": "Nous sommes là pour vous aider. N’hésitez pas à nous contacter.",
      "title": "Cet exercice a été envoyé par Moxso"
    },
    "delivered_by": {
      "text": "Cet exercice a été envoyé par Moxso pour le compte de {companyName}. Pour toute question, contactez {contactEmail}.",
      "title": "À propos de cet exercice"
    },
    "preview": "Aperçu de l’e-mail",
    "resilience_score": {
      "text": "Votre score de résilience mesure votre capacité à résister aux cyberattaques.",
      "title": "Votre score de résilience"
    },
    "submission": {
      "text": "Vous avez cliqué sur un lien et êtes arrivé sur une page web fausse, mais convaincante. Lors d’une véritable attaque de phishing, vos identifiants auraient pu être volés. Heureusement, ce n’était qu’un test.",
      "title": "Que vient-il de se passer ?"
    },
    "training": {
      "button": "Commencez votre formation"
    }
  },
  "simulations": {
    "count": "Vous avez reçu {count} simulations Moxso au cours des 90 derniers jours.",
    "empty": {
      "text": "Vous n’avez reçu aucune simulation au cours des 90 derniers jours.",
      "title": "Aucune simulation trouvée"
    },
    "joined": "Inscription au programme de formation Moxso",
    "title": "Simulations",
    "tooltip": {
      "click": "Vous avez cliqué sur le lien de cette simulation",
      "report": "Vous avez signalé cette simulation",
      "submit": "Vous vous êtes connecté dans cette simulation."
    }
  },
  "sso": {
    "login_with": "Continuer avec {provider}",
    "or": "ou utilisez l’authentification unique",
    "redirect": "Redirection"
  },
  "statistics": {
    "leaderboard": "Classement",
    "missing_data": {
      "text": "Vous devez gagner des points pour voir votre position dans le classement",
      "title": "Gagnez des points pour voir votre classement"
    },
    "points_earned": "{count} points gagnés",
    "resilience_score": "Score de résilience"
  },
  "videos": {
    "error": "La lecture vidéo est actuellement indisponible",
    "latest": "Dernières vidéos",
    "more": "Voir plus",
    "not_available_in_your_locale": "Cette vidéo n’est pas disponible en français. Nous avons automatiquement sélectionné une autre langue.",
    "play": "Lire la vidéo",
    "quiz": {
      "resume": "Reprendre le quiz",
      "title": "Quiz"
    },
    "related": "Vidéos associées",
    "related_videos": "Vidéos suggérées",
    "title": "Vidéos",
    "watch_again": "Regarder à nouveau"
  }
}
